export default __webpack_public_path__ + "static/media/Lauded Curatic Band.b19f810b.jpg";